// extracted by mini-css-extract-plugin
export var arrowIconWrapper = "SupportWidget-module--arrow-icon-wrapper--64e27";
export var contentContainer = "SupportWidget-module--content-container--d4611";
export var headerContainer = "SupportWidget-module--header-container--436fc";
export var iconContainer = "SupportWidget-module--icon-container--79386";
export var iconWrapper = "SupportWidget-module--icon-wrapper--74d53";
export var innerContainer = "SupportWidget-module--inner-container--7ad4d";
export var primary = "SupportWidget-module--primary--08049";
export var secondary = "SupportWidget-module--secondary--b751f";
export var textSection = "SupportWidget-module--text-section--c0880";
export var widgetWrapper = "SupportWidget-module--widget-wrapper--b631a";